// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__GCeTp","footer":"ModalFilter_footer__25t8C"};